// Amp owns its body-level iframe. Temporarily release only the native dialog
// containing our trigger after that actual frame is visible, then restore the
// same browsing dialog when Amp hides/removes its frame. No vendor mutation,
// history change, iframe reparenting, signup handling or requests occur here.
const installations=new WeakMap(),MAX_WAIT_MS=15000;
const noop=()=>({installed:false,dispose(){}});
function visibleFrame(win,doc){
 const frame=doc.getElementById('BIS_frame');
 if(!frame||frame.tagName!=='IFRAME'||frame.ownerDocument!==doc||!frame.isConnected||frame.hidden===true)return null;
 try{const style=win.getComputedStyle(frame),rect=frame.getBoundingClientRect();
  return style.display!=='none'&&!['hidden','collapse'].includes(style.visibility)&&Number(style.opacity)!==0&&rect.width>0&&rect.height>0?frame:null;
 }catch{return null;}
}

export function installAmpDialogBridge(win,{waitMs=MAX_WAIT_MS}={}){
 const doc=win?.document;
 if(!doc||win.FIF_PREVIEW_CONFIG?.ampRestockEnabled!==true||typeof doc.addEventListener!=='function'
   ||typeof win.MutationObserver!=='function'||typeof win.getComputedStyle!=='function'
   ||typeof win.setTimeout!=='function'||typeof win.clearTimeout!=='function'
   ||!Number.isFinite(waitMs)||waitMs<1||waitMs>MAX_WAIT_MS)return noop();
 if(installations.has(doc))return installations.get(doc);
 let pending=null,disposed=false;
 function onClick(event){
  if(disposed||win.FIF_PREVIEW_CONFIG?.ampRestockEnabled!==true)return;
  const button=event.target?.closest?.('.BIS_trigger[data-fif-restock-sku]');
  if(!button||button.ownerDocument!==doc||!button.isConnected)return;
  const dialog=button.closest?.('dialog[open]');
  if(!dialog||dialog.ownerDocument!==doc||dialog.tagName!=='DIALOG'||dialog.open!==true
    ||typeof dialog.close!=='function'||typeof dialog.showModal!=='function'||!doc.body)return;
  // Duplicate clicks keep the same original browsing snapshot and observers.
  if(pending)return;
  const href=String(win.location?.href||''),scrollTop=dialog.scrollTop;
  if(!href)return;
  let released=false,ended=false,frame=null,frameObserver=null,timer=null;
  const bodyObserver=new win.MutationObserver(inspect);
  function cleanup(){
   if(ended)return;ended=true;bodyObserver.disconnect();frameObserver?.disconnect();
   if(timer!==null)win.clearTimeout(timer);timer=null;
   if(pending===watch)pending=null;
  }
  function restore(){
   const shouldRestore=released&&!disposed&&dialog.isConnected&&String(win.location?.href||'')===href
    &&!doc.querySelector('dialog[open]');
   cleanup();if(!shouldRestore)return;
   try{dialog.showModal();dialog.scrollTop=Number.isFinite(scrollTop)?Math.max(0,scrollTop):0;
    if(button.isConnected&&dialog.contains(button))button.focus?.({preventScroll:true});
    else dialog.focus?.({preventScroll:true});
   }catch{/* A concurrent UI transition owns the next view; do not retry. */}
  }
  function observeFrame(){
   const next=doc.getElementById('BIS_frame');if(next===frame)return;
   frameObserver?.disconnect();frameObserver=null;frame=next;
   if(frame?.tagName==='IFRAME'&&frame.ownerDocument===doc){frameObserver=new win.MutationObserver(inspect);frameObserver.observe(frame,{attributes:true,attributeFilter:['style','class','hidden']});}
  }
  function inspect(){
   if(ended)return;observeFrame();const visible=visibleFrame(win,doc);
   if(released){if(!visible)restore();return;}
   if(String(win.location?.href||'')!==href||!dialog.isConnected||dialog.open!==true){cleanup();return;}
   if(!visible)return;
   // Visibility, not a click or vendor promise alone, proves that releasing the
   // native top layer will reveal the real Amp form.
   try{dialog.close();released=dialog.open===false;}catch{cleanup();return;}
   if(released&&timer!==null){win.clearTimeout(timer);timer=null;}
  }
  const watch={dispose:cleanup};pending=watch;
  bodyObserver.observe(doc.body,{childList:true,subtree:true});observeFrame();
  timer=win.setTimeout(()=>{if(!released)cleanup();},waitMs);inspect();
 }
 // Capture only schedules observation; Amp receives the original event intact.
 doc.addEventListener('click',onClick,true);
 const api={installed:true,dispose(){if(disposed)return;disposed=true;pending?.dispose();doc.removeEventListener('click',onClick,true);installations.delete(doc);}};
 installations.set(doc,api);return api;
}

if(typeof window!=='undefined')installAmpDialogBridge(window);
